module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tree-panel-filter"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.searchterm),
      expression: "filter.searchterm"
    }],
    attrs: {
      "placeholder": "search infobit"
    },
    domProps: {
      "value": (_vm.filter.searchterm)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.searchTree($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filter, "searchterm", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "context-filter"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "id": "checkbox",
      "disabled": !_vm.selectedInfobit
    },
    domProps: {
      "checked": _vm.contextFilter
    },
    on: {
      "change": _vm.setContextFilter
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "clickable",
    attrs: {
      "disabled": !_vm.selectedInfobit,
      "for": "checkbox"
    }
  }, [_vm._v("context filter")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-9b03a7aa!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tree-panel-filter.vue
// module id = 149
// module chunks = 0